import { artifactPresentationText as text } from './artifact-presentation.text.js';
import type { Artifact } from '@aimo/contracts/web';

export function artifactPresentation(artifact?: Artifact): NonNullable<Artifact['presentation']> {
  if (artifact?.origin === 'uploaded') return 'reference';
  return artifact?.presentation ?? 'intermediate';
}
export function presentationLabel(artifact?: Artifact): string {
  return { reference: text.reference, deliverable: text.deliverable, intermediate: text.intermediate, evidence: text.evidence }[artifactPresentation(artifact)];
}
